import { render, staticRenderFns } from "./currentSales.vue?vue&type=template&id=ff033522"
import script from "./currentSales.vue?vue&type=script&lang=js"
export * from "./currentSales.vue?vue&type=script&lang=js"
import style0 from "./currentSales.vue?vue&type=style&index=0&id=ff033522&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports